// extracted by mini-css-extract-plugin
module.exports = {"header":"ScenariosTable_header__3JrZg","root":"ScenariosTable_root__DzSVE","formItem":"ScenariosTable_formItem__gxWGl","tableWrapper":"ScenariosTable_tableWrapper__ASHuW"};